import ValidationError from './ValidationError.component';

export default ValidationError;